import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M23.5 3.26V3.2a2.7 2.7 0 0 0-4.92-1.53 2.69 2.69 0 0 0-4.38 0 2.69 2.69 0 0 0-4.4 0 2.69 2.69 0 0 0-4.38 0A2.68 2.68 0 0 0 3.2.5 2.71 2.71 0 0 0 .5 3.26a2.66 2.66 0 0 0 1.12 2.17 2.68 2.68 0 0 0 0 4.37 2.69 2.69 0 0 0 0 4.4 2.68 2.68 0 0 0 0 4.37A2.73 2.73 0 0 0 3.2 23.5a2.69 2.69 0 0 0 2.18-1.13 2.67 2.67 0 0 0 4.36 0 2.67 2.67 0 0 0 4.36 0 2.67 2.67 0 0 0 4.36 0 2.69 2.69 0 0 0 2.34 1.13 2.71 2.71 0 0 0 2.7-2.76 2.66 2.66 0 0 0-1.12-2.17 2.68 2.68 0 0 0 0-4.37 2.69 2.69 0 0 0 0-4.4 2.68 2.68 0 0 0 0-4.37 2.66 2.66 0 0 0 1.12-2.17ZM5 6a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1Z",
        fill: "currentColor"
      }),
      _createElementVNode("path", {
        d: "m9.64 13.76-1.19 2a.5.5 0 0 0 .43.76h7.94a.5.5 0 0 0 .48-.65l-1.62-5.28a.49.49 0 0 0-.9-.12L12.3 14.5a.5.5 0 0 1-.75.13l-1.16-1a.5.5 0 0 0-.75.13Z",
        fill: "currentColor"
      }),
      _createElementVNode("path", {
        fill: "currentColor",
        d: "M7 9a2 2 0 1 0 4 0 2 2 0 1 0-4 0"
      })
    ], -1)
  ])))
}
export default { render: render }